const language = {
  en: {
    search: "Search",
    placeholder: "What Movie do you like to watch...",
  },
  tam: {
    search: "தேடு",
    placeholder: "நீங்கள் பார்க்க விரும்பும் படம் எது...",
  },
  hin: {
    search: "खोज",
    placeholder: "आप कौन सी मूवी देखना पसंद करते हैं...",
  },
  kor: {
    search: "찾다",
    placeholder: "어떤 영화를 보고 싶은지...",
  },
};
export default language;
